import { Link } from 'react-router-dom';
import { Phone, FileText, MessageSquare } from 'lucide-react';

export default function StickyActionBar() {
  return (
    <div className="fixed bottom-0 left-0 right-0 z-40 bg-cwc-navy border-t border-white/10 shadow-[0_-4px_20px_rgba(0,0,0,0.3)]" data-testid="sticky-action-bar">
      <div className="max-w-5xl mx-auto px-4 py-2.5 flex flex-col sm:flex-row items-center justify-between gap-2">
        <p className="text-white text-xs sm:text-sm font-semibold whitespace-nowrap hidden md:block" data-testid="sticky-bar-text">
          Get Quality and Affordable Workers' Comp Insurance
        </p>
        <div className="flex items-center gap-2 sm:gap-3 w-full sm:w-auto justify-center">
          <a
            href="tel:+14159282886"
            className="flex items-center gap-1.5 bg-green-600 text-white text-[11px] sm:text-xs font-bold px-3 sm:px-4 py-2 rounded-full hover:bg-green-700 transition-colors whitespace-nowrap"
            data-testid="sticky-bar-call"
          >
            <Phone className="w-3.5 h-3.5" />
            Talk To An Agent
          </a>
          <a
            href="/#lead-form"
            className="flex items-center gap-1.5 bg-red-600 text-white text-[11px] sm:text-xs font-bold px-3 sm:px-4 py-2 rounded-full hover:bg-red-700 transition-colors whitespace-nowrap"
            data-testid="sticky-bar-quote"
          >
            <FileText className="w-3.5 h-3.5" />
            Get A Quote
          </a>
          <Link
            to="/about#contact-form"
            className="flex items-center gap-1.5 bg-white/10 text-white text-[11px] sm:text-xs font-bold px-3 sm:px-4 py-2 rounded-full hover:bg-white/20 transition-colors whitespace-nowrap border border-white/20"
            data-testid="sticky-bar-contact"
          >
            <MessageSquare className="w-3.5 h-3.5" />
            Contact Us
          </Link>
        </div>
      </div>
    </div>
  );
}
